import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface RouteWatcherProps {
  onRouteChange: () => void;
}

const RouteWatcher: React.FC<RouteWatcherProps> = ({ onRouteChange }) => {
  const location = useLocation();

  useEffect(() => {
    onRouteChange();
  }, [location, onRouteChange]);

  return null;
};

export default RouteWatcher;
